import { Box } from '@mui/material';
import logo from '../images/styalica-logo.png';
import MenuBar from './MenuBar';
import MenuItem from '../models/MenuItem';
import MobileMenu from './MobileMenu';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AboutUsPage from '../Pages/AboutUsPage';
import FurniturePage from '../Pages/FurniturePage';
import HardwarePage from '../Pages/HardwarePage';
import HomePage from '../Pages/HomePage';

interface HeaderProps {
    isMobile: boolean,
}

function Header(props: HeaderProps) {
    const navigate = useNavigate();

    const handleGeneralClick = () => {
        console.log('Redirecting to Home Page');
        navigate('/');
    }

    const handleFurnitureClick = () => {
        console.log('Redirecting to Furniture Page');
        navigate('/furniture');
    }

    const handleHardwareClick = () => {
        console.log('Redirecting to Hardware Page');
        navigate('/it-hardware');
    }

    const handleAboutUsClick = () => {
        console.log('Redirecting to About Us Page');
        navigate('/about');
    }

    const [menuItems] = useState<MenuItem[]>([
        { label: 'home', path: '/', component: <HomePage />, redirectTo: handleGeneralClick },
        { label: 'about us', path: '/about', component: <AboutUsPage />, redirectTo: handleAboutUsClick },
        { label: 'furniture', path: '/furniture', component: <FurniturePage includeDetails={true} />, redirectTo: handleFurnitureClick },
        { label: 'technology', path: '/it-hardware', component: <HardwarePage includeDetails={true} />, redirectTo: handleHardwareClick },
    ]);
    return (
        <Box>
            {props.isMobile ?
                <Box sx={{ backgroundColor: '#281404', height: '7vmax', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                    <MobileMenu menuItems={menuItems} />
                    <div style={{ width: '70%', height: '6vmax', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <img src={logo} className="App-logo" alt="logo" style={{ height: '90%', pointerEvents: 'none', padding: "5px" }} />
                    </div>
                </Box>
                :
                <Box sx={{ backgroundColor: '#281404', height: '6.5vmax', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                    <img src={logo} className="App-logo" alt="logo" style={{ height: '75%', pointerEvents: 'none', padding: "5px" }} />
                    <MenuBar menuItems={menuItems} />
                </Box>
            }
        </Box>
    );
}

export default Header;